export var MessengerState;
(function (MessengerState) {
    MessengerState["Hidden"] = "hidden";
    MessengerState["Minimized"] = "minimized";
    MessengerState["Maximized"] = "maximized";
})(MessengerState || (MessengerState = {}));
export var EnableRegistration;
(function (EnableRegistration) {
    EnableRegistration[EnableRegistration["Normal"] = 0] = "Normal";
    EnableRegistration[EnableRegistration["Registration"] = 1] = "Registration";
    EnableRegistration[EnableRegistration["Proactive"] = 2] = "Proactive";
})(EnableRegistration || (EnableRegistration = {}));
